import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-2-5.667v4.334c0 .736-.597 1.333-1.333 1.333h-4.334a.333.333 0 1 1 0-.667h4.334a.667.667 0 0 0 .666-.666v-4.334a.333.333 0 0 1 .667 0zm-4.81-1.521c.131.13.342.13.473 0l3.67-3.674v2.145a.333.333 0 0 0 .334.326.328.328 0 0 0 .333-.326V6.327A.324.324 0 0 0 17.675 6H14.72a.333.333 0 0 0-.327.333.328.328 0 0 0 .327.334h2.147L13.19 10.34a.334.334 0 0 0 0 .472zm-2.85 2.379a.334.334 0 1 1 .472.472l-3.674 3.67h2.145a.328.328 0 0 1 .326.334c0 .181-.145.33-.326.333H6.327a.323.323 0 0 1-.23-.095.333.333 0 0 1-.097-.23V14.72a.328.328 0 0 1 .333-.327c.182 0 .33.146.334.327v2.147l3.673-3.676zM6 7.333v4.334a.333.333 0 0 0 .667 0V7.333c0-.368.298-.666.666-.666h4.334a.333.333 0 0 0 0-.667H7.333C6.597 6 6 6.597 6 7.333z"
});

var SvgExpandFilled = function SvgExpandFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgExpandFilled;